export type MetricDeltaArrowDirection = 'up' | 'down' | null;

export const resolveMetricDeltaArrowDirection = (
  deltaValue: number | null,
): MetricDeltaArrowDirection => {
  if (deltaValue === null || deltaValue === 0) return null;
  return deltaValue < 0 ? 'down' : 'up';
};
